import { createVanIconComponent } from "./van"

const MapMarked = createVanIconComponent("map-marked")
export default MapMarked
